import React, { useState } from "react";
// import { useParams, useLocation } from 'react-router-dom';
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import LineViewTab from "../../components/LineViewTable/LineViewTable"; 
import MenuBar from "../../components/MenuBar/MenuBar";
import Filters from "../../components/FilterSection/FilterSection"; 
import { useDataContext } from "../../components/DataContext/PortfolioDataContext"; // Import the context

const LineViewTable: React.FC = () => {
  // const { id } = useParams();
  // const location = useLocation();
  // const cardData = location.state?.cardData;

  const { filters, setFilters ,searchQuery, setSearchQuery } = useDataContext();

  const [isFiltersOpen, setIsFiltersOpen] = useState(false); 
  const [, setRefreshCounter] = useState(0);
    const handleRefresh = () => {
      setRefreshCounter((prev) => prev + 1); 
    }; 

  const handleFilterToggle = () => {
    setIsFiltersOpen(!isFiltersOpen);
  };

  const handleApplyFilter = (filtersData: any) => {
    setFilters({
      selectedAssetType: filtersData.filters.asset_type.value[0] || "",
      selectedISO: filtersData.filters.iso.value[0] || '',
      sortField: filtersData.sort_by?.split(' ')[0] || '',
      sortOrder: filtersData.sort_by?.split(' ')[1] as 'Ascending' | 'Descending' || 'Ascending',
      groupByField: filtersData.group_by || ''
    });
    setIsFiltersOpen(false); 
  };

  return (
    <div className="flex flex-col min-h-screen bg-[#F7F7FF]">
      <Header />

      <MenuBar onFilterToggle={handleFilterToggle}  searchQuery={searchQuery}
  setSearchQuery={setSearchQuery} onRefresh={handleRefresh} />

      <div className="flex-grow relative">
        {/* Main Content (LineViewTab) */}
        <LineViewTab
          selectedAssetType={filters.selectedAssetType}
          selectedISO={filters.selectedISO}
          sortBy={filters.sortField}
          sortOrder={filters.sortOrder}
          groupBy={filters.groupByField}
          searchQuery={searchQuery}
        />
      </div>

      <Footer />

      {/* Overlay for the filter popup */}
      {isFiltersOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-40"
          onClick={() => setIsFiltersOpen(false)} 
        ></div>
      )}

      <div
        className={`fixed top-24 right-0 bottom-0 w-70 sm:w-70 z-50 bg-white shadow-lg transform transition-all duration-500 overflow-y-auto
          ${isFiltersOpen ? "opacity-100 translate-x-0" : "opacity-0 translate-x-full"}`}
        style={{
          maxHeight: "calc(97vh - 96px)",
          minHeight: "calc(85vh - 96px)",
        }}
      >
        <Filters setIsFiltersOpen={setIsFiltersOpen} onApplyFilter={handleApplyFilter} />
      </div>
    </div>
  );
};

export default LineViewTable;
